var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFuelLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1196,
    height: 395,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.2 51.54h-26.14c-43.94.37-68.14 22.8-68.14 63.1v15.96H7.33C3 130.6 0 134.47 0 137.92v27.7c0 4.32 3 7.33 7.33 7.33h26.59v157.83c0 4.3 3.5 7.32 8.5 7.32h37.44c4.76 0 7.72-2.84 7.72-7.32V172.95H129a7.78 7.78 0 005.56-2.05 6.99 6.99 0 001.67-2.42c.37-.9.54-1.88.49-2.85v-27.71c0-3.51-2.65-7.31-6.94-7.31h-42.2v-17.86c0-13.69 6.69-19.28 23.09-19.28H129c5.3 0 7.72-3.6 7.72-6.94V58.85c-.01-3.37-2.23-7.31-8.51-7.31zM341.9 129.13h-37.44c-4.83 0-7.72 2.84-7.72 7.68v125.55c-7.73 20.07-24.57 33.03-43 33.03-19.66 0-30.5-11.58-30.5-32.59V136.78c0-4.89-3-7.68-8.1-7.68h-37c-5.08 0-8.5 3.09-8.5 7.68V270.2c0 44.4 25.22 72.01 65.83 72.01 23.86 0 46.48-10.42 62.46-28.67v17.25c0 4.38 3.25 7.32 8.1 7.32h36.27c4.7 0 8.11-3.08 8.11-7.32V136.8c-.02-4.75-3.28-7.68-8.52-7.68zM490.84 125.07c-57.43 0-93.1 31.97-93.1 83.43v50.22c0 51.46 36 83.43 93.88 83.43 41.27 0 72.7-16.28 86.21-44.62 1.57-2.97 2-5.35 1.35-7.5-.72-2.38-2.63-4.24-6-5.84l-24.65-11.87a13.78 13.78 0 00-5.49-1.43c-3.6 0-5.76 2.23-8.13 5.89-6.82 12.6-14.76 23.02-42.83 23.02-27.88-.34-42.6-14.29-42.6-40.34v-9.32h118.57c8.46 0 12.4-3.6 12.4-11.37v-31.02c0-51-34.33-82.68-89.6-82.68zm-.78 42.35c25.82 0 40.63 14.3 40.63 39.23v8.2h-81.25v-8.2c0-24.94 14.8-39.24 40.62-39.24zM672.16 51.17h-37c-5.24 0-8.5 2.94-8.5 7.68v271.57c0 4.73 3.26 7.68 8.5 7.68h37c4.93 0 8.12-3.02 8.12-7.68V58.85c0-4.67-3.2-7.68-8.12-7.68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M1121.68 339h-53.94v-56.23h53.94a18.12 18.12 0 0018.11-18.1V76.34a18.15 18.15 0 00-18.11-18.1h-188.4a18.12 18.12 0 00-18.1 18.11v55.14H859V76.33A74.41 74.41 0 01933.29 2h188.39A74.41 74.41 0 011196 76.33v188.35a74.4 74.4 0 01-74.32 74.32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M1007.81 395H865.2a63.38 63.38 0 01-44.67-18.46 62.91 62.91 0 01-18.53-44.5V189.95a62.91 62.91 0 0118.53-44.5A63.38 63.38 0 01865.2 127H1071v205.04a62.9 62.9 0 01-18.53 44.5 63.37 63.37 0 01-44.66 18.46zM865.2 183.17a6.83 6.83 0 00-6.8 6.78v142.09a6.77 6.77 0 006.8 6.78h142.61a6.81 6.81 0 006.81-6.78V183.17H865.2z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 995.28,
    x2: 1139.04,
    y1: 202.73,
    y2: 58.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#206E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#2E7FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#499EC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#53AACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 779.5,
    x2: 1069.19,
    y1: 422.14,
    y2: 122.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#206E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#53AACC"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelLogoWhite);
export default __webpack_public_path__ + "static/media/fuel-logo-white.2b7f3c9b56c3e4c19bb0a33fe9e2f2e7.svg";
export { ForwardRef as ReactComponent };